import * as React from 'react';
import { Button } from '@/components/ui/Button';
import { useUiStore } from '@/store/uiStore';

export const NoEchoState: React.FC = () => {
  const openModal = useUiStore((state) => state.openModal);

  return (
    <div className='flex h-full flex-col items-center justify-center gap-6 p-6'>
      <h2 className='text-2xl font-bold text-brand-800'>No Echo Found</h2>
      <p className='text-gray-600'>You haven&apos;t created a digital echo yet.</p>
      <Button onClick={() => openModal('creator')} variant='purple-dark' className='px-8'>
        Create Your Echo
      </Button>
    </div>
  );
};
